import React, { useEffect, useRef, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { Navbar } from "./sections/Navbar";
import { Hero } from "./sections/Hero";
import { WhyChooseUs } from "./sections/WhyChooseUs";
import { ProductShowcase } from "./sections/ProductShowcase";
import { FarmToBusiness } from "./sections/FarmToBusiness";
import { QualityPromise } from "./sections/QualityPromise";
import { IndustriesServed } from "./sections/IndustriesServed";
import { DryFruits } from "./sections/DryFruits";
import { BangalorePresence } from "./sections/BangalorePresence";
import { Testimonials } from "./sections/Testimonials";
import { FAQ } from "./sections/FAQ";
import { EnquiryForm } from "./sections/EnquiryForm";
import { StrongCTA } from "./sections/StrongCTA";
import { Contact } from "./sections/Contact";
import { Footer } from "./sections/Footer";
import { FloatingActions } from "./sections/FloatingActions";
// import { LeadPopup } from "./sections/LeadPopup";
import { WholesaleQuotePopup } from "./sections/WholesaleQuotePopup";
import { QuotePopupProvider } from "./context/QuotePopupContext";
import AdminPage from "./pages/AdminPage";

const Landing = () => {
  // Existing exit-intent + timed mini popups
  const [timedOpen, setTimedOpen] = useState(false);
  const [exitOpen, setExitOpen] = useState(false);
  const shownTimed = useRef(false);
  const shownExit = useRef(false);

  useEffect(() => {
    if (sessionStorage.getItem("ms_lead_shown") === "1") {
      shownTimed.current = true;
      shownExit.current = true;
      return;
    }
    const t = setTimeout(() => {
      if (shownTimed.current || shownExit.current) return;
      shownTimed.current = true;
      setTimedOpen(true);
    }, 25000);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("ms_lead_shown") === "1") return;
    const onMouseLeave = (e) => {
      if (shownExit.current || shownTimed.current) return;
      if (e.clientY <= 0 && e.relatedTarget == null) {
        shownExit.current = true;
        setExitOpen(true);
      }
    };
    document.addEventListener("mouseleave", onMouseLeave);
    return () => document.removeEventListener("mouseleave", onMouseLeave);
  }, []);

  const closeTimed = (v) => {
    setTimedOpen(v);
    if (!v) sessionStorage.setItem("ms_lead_shown", "1");
  };
  const closeExit = (v) => {
    setExitOpen(v);
    if (!v) sessionStorage.setItem("ms_lead_shown", "1");
  };

  return (
    <div className="App bg-[#FAF8F2] text-[#2A2A2A]" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <WhyChooseUs />
        <ProductShowcase />
        <FarmToBusiness />
        <QualityPromise />
        <IndustriesServed />
        <DryFruits />
        <BangalorePresence />
        <Testimonials />
        <FAQ />
        <EnquiryForm />
        <StrongCTA />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />

      {/* Primary CTA popup (opens from all CTAs) */}
      <WholesaleQuotePopup />

      {/* Existing mini popups */}
      {/* <LeadPopup open={timedOpen} onOpenChange={closeTimed} kind="timed" /> */}
      {/* <LeadPopup open={exitOpen} onOpenChange={closeExit} kind="exit" /> */}
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <QuotePopupProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: "#0E4D3D",
              color: "#FAF8F2",
              border: "1px solid #C9A227",
              borderRadius: "0",
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
      </QuotePopupProvider>
    </BrowserRouter>
  );
}

export default App;
